import _throttle2 from "lodash/throttle";
import React, { useState, useEffect } from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { Link } from '@latitude/link';
import { ANALYTICS, BUTTON_STYLE } from '@latitude/core/utils/constants';
import SvgInline from '@latitude/svg-inline';
import './_sticky-cta.scss';

var StickyCta = function StickyCta(props) {
  var children = props.children,
      href = props.href,
      trackId = props.trackId,
      text = props.text,
      targetBlank = props.targetBlank,
      triggerElem = props.triggerElem,
      phoneNumber = props.phoneNumber;

  var _useState = useState(!triggerElem),
      active = _useState[0],
      setActive = _useState[1]; // when to trigger the sticky


  var trigger = triggerElem && typeof document !== 'undefined' && document.querySelector(triggerElem) && document.querySelector(triggerElem).getBoundingClientRect().top + window.pageYOffset;

  var throttleEvent = _throttle2(function () {
    setActive(window.pageYOffset > trigger);
  }, 300);

  useEffect(function () {
    if (triggerElem) {
      // scroll event
      document.addEventListener('scroll', throttleEvent);
    }

    return function () {
      document.removeEventListener('scroll', throttleEvent);
    };
  }, []);
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: ANALYTICS.LOCATION.STICKY_CTA
  }, /*#__PURE__*/React.createElement("div", {
    className: "sticky-cta " + (active ? 'sticky-cta--active' : '')
  }, children || /*#__PURE__*/React.createElement("div", {
    className: "sticky-cta__inner"
  }, phoneNumber && /*#__PURE__*/React.createElement(Link, {
    noStyle: true,
    className: "sticky-cta__phone text-white",
    trackId: "sticky-cta-phone",
    href: "tel:" + phoneNumber,
    trackEventData: {
      label: phoneNumber
    }
  }, /*#__PURE__*/React.createElement(SvgInline, {
    strokeWhite: true,
    fillWhite: true,
    className: "sticky-cta__phone-icon text-white",
    name: "phone"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sticky-cta__phone-number text-white"
  }, phoneNumber)), /*#__PURE__*/React.createElement(Link, {
    button: BUTTON_STYLE.PRIMARY,
    href: href,
    trackId: trackId,
    target: targetBlank ? '_blank' : null,
    className: "sticky-cta__button"
  }, text || 'Apply now'))));
};

export default StickyCta;